import type { SettingsInput, TenantSettings } from '@provalia/shared';
import { SettingsForm } from '../../shared/SettingsForm';
import { api } from '../api';
import { usePortal } from '../context';

export function Configuracion(): JSX.Element {
  const { me, reloadMe } = usePortal();
  return (
    <div className="stack lg">
      <div className="page-head">
        <div>
          <h1>Configuración del portal</h1>
          <p className="muted">Tolerancias de precio y fecha, avisos por correo, evaluación de proveedores y planos.</p>
        </div>
      </div>
      <SettingsForm
        load={() => api.get<{ settings: TenantSettings; defaults: TenantSettings }>('/portal/settings')}
        save={async (input: SettingsInput) => {
          const res = await api.put<{ settings: TenantSettings }>('/portal/settings', input);
          // Las tolerancias que ve el portal (avisos en vivo) salen de /me.
          void reloadMe();
          return res;
        }}
        testEmail={(to) => api.post('/portal/settings/test-email', { to })}
        defaultTestTo={me.session.email}
      />
    </div>
  );
}
